import React, { useState } from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import { useAppContext } from '../../../../../Services/AppContext';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import useFilters from '../../../../Base/Hooks/useFilters';

export interface ClosedCasesFilterValues {
	solvedAt?: string;
	patientId?: string;
	doctorId?: string;
	caseTypeIds?: string[];
	workplaceId: string;
	solvedAtRange?: {
		from: string;
		to: string;
	};
}

interface Props {
	onFilter: (values: ClosedCasesFilterValues) => void;
	dataCount?: number | null;
}

const ClosedCasesFilter: React.FC<Props> = ({ onFilter, dataCount }) => {
	const {
		handleDateRange,
		handleDateRangeVisibility,
		handleDateRangeInPicker,
		isDateRangeVisible,
	} = useFilters();
	const { workplaceId } = useAppContext();
	const onFilterData = (values: any) => {
		handleDateRangeVisibility(values?.solvedAt?.value);
		const filter: ClosedCasesFilterValues = {
			solvedAt: handleDateRangeInPicker(values?.solvedAt?.value),
			patientId: values?.patient?.value || undefined,
			doctorId: values?.medicId?.value || undefined,
			caseTypeIds:
				values?.caseTypeIds?.map((caseType: SelectValue) => caseType?.value) ||
				undefined,
			solvedAtRange: handleDateRange(values?.dateFrom, values?.dateTo),
			workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			isFilterOpen={isDateRangeVisible}
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.CLOSED_CASES_FILTER}
			dataCount={dataCount}>
			<GridFilterItem
				type={GridFilterItemType.CASE_TYPE}
				width={320}
				customPlaceholder='base.shared.pick'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.ANY_MEDIC_ID}
				width={380}
				customPlaceholder='base.startTypingSurname'
				customLabel='base.closedByMedic'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.SOLVED_AT}
				width={240}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={170}
				customLabel='base.shared.from'
				enableAutocomplete
				visible={isDateRangeVisible}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				width={170}
				customLabel='base.shared.to'
				enableAutocomplete
				visible={isDateRangeVisible}
			/>
		</GridFilter>
	);
};

export default ClosedCasesFilter;
